import { SourceEntityDetailDto } from '@/api/backoffice/clients';

export const sourceEntityLabel = (detail: SourceEntityDetailDto) => {
    return `${detail.code} (${detail.label})`;
};

export const copySourceEntityValues = (from: SourceEntityDetailDto, to: SourceEntityDetailDto) => {
    if (from?.id === to?.id) {
        to.code = from.code;
        to.label = from.label;
        to.description = from.description;
        to.crs = from.crs;
        to.schema = from.schema;
        to.model = from.model;
        to.dataConnection = from.dataConnection;
    }
};
